<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div
          class="modal-wrapper"
          @click.self="hideModal"
        >
          <div
            id="modalContainer"
            class="modal-container"
          >
            <div
              class="modal-close"
              @click="hideModal"
            />
            <div class="modal-header">
              <div class="textLeft">
                <img
                  class="arta-logo"
                  src="@/assets/icons/arta-logo.svg"
                  alt="Arta Logo"
                  height="20"
                >
              </div>
            </div>

            <div class="modal-body">
              <h1>
                Leland Little uses Arta's Fulfillment technology and end-to-end global
                services to ensure that purchases are properly shipped and insured.
              </h1>
              <h2 class="arta-green">
                Arta's expert team spans various luxury sectors, ensuring meticulous
                handling and communication throughout the shipping process.
              </h2>
              <div class="body-row-wrapper">
                <div class="body-row">
                  <div class="body-col">
                    <div>
                      <img
                        class="arta-section-icon"
                        src="@/assets/icons/world.png"
                        alt="Holistic solution"
                      >
                    </div>
                    <h1 class="arta-green">
                      For a holistic solution
                    </h1>
                    <p>
                      Arta manages shipping, insurance, packing, customs clearance,
                      customer service, shipment management, destination services, and
                      everything in between.
                    </p>
                  </div>
                  <div class="body-col">
                    <div>
                      <img
                        class="arta-section-icon"
                        src="@/assets/icons/shield.png"
                        alt="Peace of mind"
                      >
                    </div>
                    <h1 class="arta-green">
                      For peace of mind
                    </h1>
                    <p>
                      Arta offers industry-leading insurance coverage with an “all-risks”
                      transit insurance policy, including restoration and repair,
                      supported by a dedicated claims team.
                    </p>
                  </div>
                </div>
                <div class="body-row">
                  <div class="body-col">
                    <div>
                      <img
                        class="arta-section-icon"
                        src="@/assets/icons/computer.png"
                        alt="Real time tracking"
                      >
                    </div>
                    <h1 class="arta-green">
                      For real time tracking
                    </h1>
                    <p>
                      Arta provides logistical updates via email, including anticipated
                      delivery dates, tracking information, and customs guidance,
                      throughout the shipment's journey.
                    </p>
                  </div>
                  <div class="body-col">
                    <div>
                      <img
                        class="arta-section-icon"
                        src="@/assets/icons/truck.png"
                        alt="Partner quality"
                      >
                    </div>
                    <h1 class="arta-green">
                      For partner quality
                    </h1>
                    <p>Arta exclusively collaborates with top-tier shippers.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="footer">
              Email Arta @ <a href="mailto:hello@arta.io">hello@arta.io</a>, they will get back to you
              within one business
              day.<br>
              The New York office general line is +1 (646) 828-7333 and the London office
              general line is +44 (0) 2030 028467
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
    name: "ShippingOptionsInfoModalComponent",
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        hideModal: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {};
    },
    computed: {},
    mounted() { },
    methods: {},
};
</script>

<style scoped>
.modal-container {
    background: #ffffff;
    max-width: 806px;
    padding: 3rem 3rem;
    margin: 0 auto !important;
    overflow: auto;
}

.modal-container h1 {
    font-weight: 400;
    padding-top: 2rem;
    padding-bottom: 2rem;
    line-height: 3rem;
    font-size: 1.8em;
}

.modal-container h2 {
    font-weight: 400;
    padding: 2rem 0;
}

.modal-close {
    right: 1.2rem !important;
    top: 1.2rem !important;
}

.footer {
    padding-top: 3rem;
}

.arta-logo {
    width: auto;
}

.arta-green {
    color: #759e89;
}

.arta-section-icon {
    width: 40px;
    height: 40px;
}

.body-row-wrapper {
    padding-top: 2rem;
}

.body-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.body-col {
    width: 320px;
}

.body-col p {
    font-size: 1.2em;
}
@media screen and (min-width: 768px) {
    .modal-container {
        position: relative;
        padding: 4rem 5rem;
        max-height: 1080px;
    }
}
</style>
